const actionTypes = {
  SET_SITES: '@MYYOLA/SITES/SET_SITES',
  DELETE_SITE_DATA: '@MYYOLA/SITES/DELETE_SITE_DATA',
  SET_SITES_ERROR: '@MYYOLA/SITES/SET_SITES_ERROR',
};

export default actionTypes;
